import { Navigate, Route, Routes } from "react-router-dom";
import SchemaComparison from "../views/supportal/Tools/SchemaComparison/SchemaComparison";
import HealthMaintenance from "../views/supportal/HealthMaintenance/HealthMaintenance";
import SentryTesting from "../views/supportal/Tools/SentryTesting/SentryTesting";
import CacheManagement from "../views/supportal/Tools/CacheManagement/CacheManagement";
import JSONToSchema from "../views/supportal/Tools/JSONToSchema/JSONToSchema";
import CloudDetailView2 from "../views/supportal/CloudDetailView/CloudDetailView";
import TenantSchemasList from "../views/supportal/CloudDetailView/TenantSchemasList";
import OverAllCloudCosts from "../views/supportal/BrieCostTracker/OverAllCloudCosts";
import CloudModuleSchema from "../views/supportal/CloudDetailView/TenantSchema/CloudModuleSchemaView";
import ManageModuleIndexes from "../views/supportal/CloudDetailView/ModuleIndexes/ManageModuleIndexes";
import CloudAppsList from "../views/supportal/CloudDetailView/CloudApps/CloudAppsList";
import ManageCloudApp from "../views/supportal/CloudDetailView/CloudApps/ManageCloudApp";
import CloudBackupsList from "../views/supportal/CloudDetailView/CloudBackupsList";
import SupportalUsers from "../views/supportal/Users/SupportalUsers";
import PersonDetailView from "../views/supportal/PersonDetailView";
import CloudListView from "../views/supportal/CloudListView/CloudListView";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../atoms/GlobalAtoms";
import CloudTenantSchema from "../views/supportal/CloudDetailView/TenantSchema/CloudTenantSchemaView";
import GlobalVariableConstantsView from "../views/supportal/GlobalVariableConstantsView";
import GlobalVariableListDetailView from "../views/supportal/GlobalLists/GlobalVariableListDetailView";
import GlobalCRMFieldTypesView from "../views/supportal/GlobalCRMFieldTypesView";
import CRMDefaultTemplateListView from "../views/workspaces/CRMDefaultTemplateListView";
import CRMTemplateDetailView from "../views/supportal/CRMTemplateDetailView";
import CRMTemplateModuleDetailView from "../views/supportal/CRMTemplateModuleDetailView";
import GlobalVariableListsView from "../views/supportal/GlobalLists/GlobalVariableListsView";
import OrphanCollections from "../views/supportal/Tools/OrphanCollections/OrphanCollections";
import SupportalCloudsLayout from "./SupportalCloudsLayout";

export default function MissionControlLayout() {
  const tenantID = useAtomValue(tenantIDAtom);
  const urlStart = `/clouds/${tenantID}/mc`;

  return (
    <Routes>
      {/* Legacy Supportal Routes */}
      <Route path="/" element={<Navigate to={urlStart} />} />
      <Route
        path="global/variables/constants"
        element={<GlobalVariableConstantsView urlStart={urlStart} />}
      />
      <Route
        path="global/variables/lists"
        element={<GlobalVariableListsView urlStart={urlStart} />}
      />
      <Route
        path="global/variables/lists/:listID"
        element={<GlobalVariableListDetailView urlStart={urlStart} />}
      />
      <Route
        path="global/fieldtypes"
        element={<GlobalCRMFieldTypesView urlStart={urlStart} />}
      />
      <Route
        path="global/templates"
        element={<CRMDefaultTemplateListView urlStart={urlStart} />}
      />
      <Route
        path="global/templates/:templateID"
        element={<CRMTemplateDetailView urlStart={urlStart} />}
      />
      <Route
        path="global/templates/:templateID/:moduleAPIName/:tab"
        element={<CRMTemplateModuleDetailView urlStart={urlStart} />}
      />
      <Route
        path="clouds"
        element={
          <CloudListView urlStart={`/clouds/${tenantID}/mc/clouds`} mode="mc" />
        }
      />
      <Route
        path="clouds/:cloudID/:tab"
        element={
          <SupportalCloudsLayout
            urlStart={`/clouds/${tenantID}/mc/clouds`}
            mode="mc"
          />
        }
      />
      <Route
        path="clouds/:cloudID/modules"
        element={<CloudTenantSchema urlStart={`/clouds/${tenantID}/mc`} />}
      />
      <Route
        path="clouds/:cloudID/brie-cost-tracker"
        element={<OverAllCloudCosts />}
      />
      <Route
        path="clouds/:cloudID/modules/:moduleAPIName"
        element={<CloudModuleSchema />}
      />
      <Route
        path="clouds/:tenantID/modules/:APIName/indexes"
        element={<ManageModuleIndexes />}
      />
      <Route
        path="clouds/:cloudID/cloudApps/:cloudAppID"
        element={<ManageCloudApp />}
      />
      <Route path="clouds/:cloudID/schemas" element={<TenantSchemasList />} />
      <Route path="clouds/:cloudID/backups" element={<CloudBackupsList />} />
      <Route
        path="users"
        element={<SupportalUsers urlStart={`/clouds/${tenantID}/mc`} />}
      />
      <Route
        path="users/:personID"
        element={<PersonDetailView urlStart={`/clouds/${tenantID}/mc`} />}
      />
      <Route path="health-maintenance" element={<HealthMaintenance />} />
      {/* Power Tools */}
      <Route path="schema-compare" element={<SchemaComparison />} />
      <Route path="sentry" element={<SentryTesting />} />
      <Route path="cache-management" element={<CacheManagement />} />
      <Route path="json-to-schema" element={<JSONToSchema />} />
      <Route path="orphan-collections" element={<OrphanCollections />} />
    </Routes>
  );
}
